import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  putRIByScenarioId,
  unMountRiskIndicators,
  fetchRIListByScenarioId
} from '../../../../redux/actions/trm/riskIndicators';
import RiskIndicators from './riskIndicators';

function mapStateToProps(state) {
  const { scenarioRiskIndicators = {} } = state;
  const { isLoading, error, riskIndicator, list, isSaved, isLoadingList } =
    scenarioRiskIndicators;
  return {
    isLoading,
    error,
    riskIndicators: list,
    riskIndicator,
    isSaved,
    isLoadingList
  };
}

function mapDispatchToProps(dispatch) {
  return {
    riskAPIActions: bindActionCreators(
      {
        fetchRIListByScenarioId,
        unMountRiskIndicators,
        putRIByScenarioId
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RiskIndicators);
